module.exports = __webpack_public_path__ + "static/media/ic-correct.8d17f266.svg";